export default [
  {
    path: '/car/setting',
    name: 'CarSetting',
    component: () => import('./Setting.vue'),
    meta: {title: '汽车参数&模型'}
  },
]
